// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17eI_","title":"styles_title__3t_Ow"};